// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"4e837e54","851":"c7fb6359"}[chunkId] + ".chunk.css";
};